const ids = {
    user: "11111111-1111-4111-8111-111111111111",
    app: "22222222-2222-4222-8222-222222222222",
    thread: "33333333-3333-4333-8333-333333333333",
    run: "44444444-4444-4444-8444-444444444444",
    command: "55555555-5555-4555-8555-555555555555",
    event: "66666666-6666-4666-8666-666666666666",
    message: "77777777-7777-4777-8777-777777777777",
    childRun: "aaaaaaaa-aaaa-4aaa-8aaa-aaaaaaaaaaaa",
    question: "cccccccc-cccc-4ccc-8ccc-cccccccccccc",
    incident: "dddddddd-dddd-4ddd-8ddd-dddddddddddd",
    lease: "eeeeeeee-eeee-4eee-8eee-eeeeeeeeeeee",
};
function exampleTraceManifest() {
    return {
        schemaVersion: 1,
        format: "agent-run-bundle-v1",
        userId: ids.user,
        appId: ids.app,
        threadId: ids.thread,
        rootRunId: ids.run,
        correlationId: "foundation-example",
        createdAt: "2026-08-01T12:00:00.000Z",
        initialCommand: {
            protocolVersion: 1,
            commandId: ids.command,
            runId: ids.run,
            sequence: 0,
            issuedAt: "2026-08-01T12:00:00.000Z",
            type: "run.start",
            input: {
                messageId: ids.message,
                content: "Build a small shared shopping list.",
            },
        },
        platform: {
            version: "0.1.0-example",
            revision: "example-revision",
            environment: "example",
        },
        runtime: {
            adapter: "fake",
            provider: "example",
            model: null,
            reasoningEffort: null,
            workspaceRef: "workspace:example-app",
            checkpointVersion: 0,
            resources: {
                memoryBytes: 536_870_912,
                nanoCpus: 1_000_000_000,
                pidsLimit: 128,
                maxChildAgents: 2,
            },
        },
        capture: {
            liveWriteAheadLog: true,
            runtimeEvents: true,
            engineEvents: true,
            harnessDefinition: true,
            adapterRequests: true,
            exactProviderRequests: false,
            workspaceSnapshots: false,
            controlPlaneSpans: false,
        },
    };
}
export const agentProtocolExamples = {
    run: {
        schemaVersion: 1,
        id: ids.run,
        userId: ids.user,
        appId: ids.app,
        threadId: ids.thread,
        parentRunId: null,
        correlationId: "foundation-example",
        trigger: "user_message",
        status: "running",
        phase: "building",
        checkpointVersion: 0,
        createdAt: "2026-08-01T12:00:00.000Z",
        updatedAt: "2026-08-01T12:00:01.000Z",
    },
    userMessage: {
        schemaVersion: 1,
        id: ids.message,
        threadId: ids.thread,
        appId: ids.app,
        runId: ids.run,
        role: "user",
        content: "Build a small shared shopping list.",
        createdAt: "2026-08-01T12:00:00.000Z",
    },
    startCommand: {
        protocolVersion: 1,
        commandId: ids.command,
        runId: ids.run,
        sequence: 0,
        issuedAt: "2026-08-01T12:00:00.000Z",
        type: "run.start",
        input: {
            messageId: ids.message,
            content: "Build a small shared shopping list.",
        },
    },
    continueCommand: {
        protocolVersion: 1,
        commandId: "55555555-5555-4555-8555-555555555556",
        runId: ids.run,
        sequence: 1,
        issuedAt: "2026-08-01T12:05:00.000Z",
        type: "run.continue",
        checkpointVersion: 1,
    },
    answerCommand: {
        protocolVersion: 1,
        commandId: "55555555-5555-4555-8555-555555555557",
        runId: ids.run,
        sequence: 2,
        issuedAt: "2026-08-01T12:06:00.000Z",
        type: "user.answer",
        questionId: ids.question,
        input: {
            messageId: "77777777-7777-4777-8777-777777777778",
            content: "Use a private app.",
        },
    },
    cancelCommand: {
        protocolVersion: 1,
        commandId: "55555555-5555-4555-8555-555555555558",
        runId: ids.run,
        sequence: 3,
        issuedAt: "2026-08-01T12:07:00.000Z",
        type: "run.cancel",
        reason: "User cancelled the run.",
    },
    runtimeStart: {
        protocolVersion: 1,
        runId: ids.run,
        parentRunId: null,
        kind: "root",
        userId: ids.user,
        appId: ids.app,
        threadId: ids.thread,
        correlationId: "foundation-example",
        eventSequence: 0,
        trace: {
            format: "agent-run-bundle-v1",
            rootRunId: ids.run,
            eventSequence: 0,
            runtimeAttempt: 1,
            callbackUrl: `http://agent-service:3010/_internal/agent-traces/${ids.user}/${ids.app}/${ids.run}`,
            manifest: exampleTraceManifest(),
        },
        workspaceRef: "workspace:example-app",
        checkpoint: null,
        engine: {
            adapter: "fake",
            model: null,
            harnessVersion: "opencloud-product-harness-v3",
        },
        providerConnectionRef: "provider:example",
        authorityMode: "legacy_split_v1",
        authorityGrantRef: "grant:example",
        callback: {
            url: `http://agent-service:3010/_internal/runtime-events/${ids.user}/${ids.app}/${ids.run}`,
            tokenRef: `runtime-callback:${ids.run}:1`,
        },
        resources: {
            memoryBytes: 536_870_912,
            nanoCpus: 1_000_000_000,
            pidsLimit: 128,
            maxChildAgents: 2,
        },
    },
    launchRequest: {
        schemaVersion: 1,
        start: {
            protocolVersion: 1,
            runId: ids.run,
            parentRunId: null,
            kind: "root",
            userId: ids.user,
            appId: ids.app,
            threadId: ids.thread,
            correlationId: "foundation-example",
            eventSequence: 0,
            trace: {
                format: "agent-run-bundle-v1",
                rootRunId: ids.run,
                eventSequence: 0,
                runtimeAttempt: 1,
                callbackUrl: `http://agent-service:3010/_internal/agent-traces/${ids.user}/${ids.app}/${ids.run}`,
                manifest: exampleTraceManifest(),
            },
            workspaceRef: "workspace:example-app",
            checkpoint: null,
            engine: {
                adapter: "fake",
                model: null,
                harnessVersion: "opencloud-product-harness-v3",
            },
            providerConnectionRef: "provider:example",
            authorityMode: "legacy_split_v1",
            authorityGrantRef: "grant:example",
            callback: {
                url: `http://agent-service:3010/_internal/runtime-events/${ids.user}/${ids.app}/${ids.run}`,
                tokenRef: `runtime-callback:${ids.run}:1`,
            },
            resources: {
                memoryBytes: 536_870_912,
                nanoCpus: 1_000_000_000,
                pidsLimit: 128,
                maxChildAgents: 2,
            },
        },
        command: {
            protocolVersion: 1,
            commandId: ids.command,
            runId: ids.run,
            sequence: 0,
            issuedAt: "2026-08-01T12:00:00.000Z",
            type: "run.start",
            input: {
                messageId: ids.message,
                content: "Build a small shared shopping list.",
            },
        },
    },
    readyEvent: {
        protocolVersion: 1,
        eventId: ids.event,
        runId: ids.run,
        sequence: 0,
        correlationId: "foundation-example",
        occurredAt: "2026-08-01T12:00:01.000Z",
        type: "runtime.ready",
        runtimeId: "runtime:example",
        acceptsLiveUserMessages: true,
    },
    waitForUserEvent: {
        protocolVersion: 1,
        eventId: "66666666-6666-4666-8666-666666666667",
        runId: ids.run,
        sequence: 1,
        correlationId: "foundation-example",
        occurredAt: "2026-08-01T12:04:00.000Z",
        type: "user.input.required",
        questionId: ids.question,
        question: "Should this app be private or public?",
        reason: "material_decision",
    },
    childRuntimeStart: {
        protocolVersion: 1,
        runId: ids.childRun,
        parentRunId: ids.run,
        kind: "child",
        userId: ids.user,
        appId: ids.app,
        threadId: ids.thread,
        correlationId: "foundation-example",
        eventSequence: 0,
        trace: {
            format: "agent-run-bundle-v1",
            rootRunId: ids.run,
            eventSequence: 0,
            runtimeAttempt: 1,
            callbackUrl: `http://agent-service:3010/_internal/agent-traces/${ids.user}/${ids.app}/${ids.run}`,
            manifest: exampleTraceManifest(),
        },
        workspaceRef: "workspace:example-app-child",
        checkpoint: {
            version: 1,
            ref: "checkpoint:example-app:1",
            digest: "sha256:aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa",
        },
        engine: { adapter: "fake", model: null },
        providerConnectionRef: "provider:example",
        authorityMode: "legacy_split_v1",
        authorityGrantRef: "grant:example-child",
        callback: {
            url: `http://agent-service:3010/_internal/runtime-events/${ids.user}/${ids.app}/${ids.childRun}`,
            tokenRef: `runtime-callback:${ids.childRun}:1`,
        },
        resources: {
            memoryBytes: 268_435_456,
            nanoCpus: 500_000_000,
            pidsLimit: 64,
            maxChildAgents: 0,
        },
    },
    childStartedEvent: {
        protocolVersion: 1,
        eventId: "66666666-6666-4666-8666-666666666668",
        runId: ids.run,
        sequence: 2,
        correlationId: "foundation-example",
        occurredAt: "2026-08-01T12:08:00.000Z",
        type: "child.started",
        childRunId: ids.childRun,
        purpose: "Review the responsive layout.",
    },
    usage: {
        schemaVersion: 1,
        usageEventId: "88888888-8888-4888-8888-888888888888",
        appId: ids.app,
        runId: ids.run,
        childRunId: null,
        provider: "example",
        model: "example-model",
        source: "provider",
        inputTokens: 100,
        cachedInputTokens: 25,
        outputTokens: 30,
        reasoningTokens: 10,
        totalTokens: 130,
        observedAt: "2026-08-01T12:09:00.000Z",
    },
    usageEvent: {
        protocolVersion: 1,
        eventId: "66666666-6666-4666-8666-666666666669",
        runId: ids.run,
        sequence: 3,
        correlationId: "foundation-example",
        occurredAt: "2026-08-01T12:09:00.000Z",
        type: "usage.reported",
        usage: {
            schemaVersion: 1,
            usageEventId: "88888888-8888-4888-8888-888888888888",
            appId: ids.app,
            runId: ids.run,
            childRunId: null,
            provider: "example",
            model: "example-model",
            source: "provider",
            inputTokens: 100,
            cachedInputTokens: 25,
            outputTokens: 30,
            reasoningTokens: 10,
            totalTokens: 130,
            observedAt: "2026-08-01T12:09:00.000Z",
        },
    },
    incident: {
        schemaVersion: 1,
        id: ids.incident,
        userId: ids.user,
        appId: ids.app,
        correlationId: "foundation-incident",
        source: "health",
        kind: "live_check_failed",
        severity: "error",
        title: "The live app health check failed",
        summary: "Three consecutive live checks returned HTTP 500.",
        observedAt: "2026-08-01T12:10:00.000Z",
        evidenceRefs: ["evidence:health-check:123"],
        provenance: {
            trusted: true,
            sourceEventId: "health-check-123",
        },
        policy: {
            unattendedEligible: true,
            reason: "A bounded application repair is allowed.",
        },
    },
    lease: {
        schemaVersion: 1,
        leaseId: ids.lease,
        appId: ids.app,
        runId: ids.run,
        acquiredAt: "2026-08-01T12:00:00.000Z",
        expiresAt: "2026-08-01T12:01:00.000Z",
        generation: 1,
    },
    failedEvent: {
        protocolVersion: 1,
        eventId: "66666666-6666-4666-8666-666666666670",
        runId: ids.run,
        sequence: 4,
        correlationId: "foundation-example",
        occurredAt: "2026-08-01T12:11:00.000Z",
        type: "run.failed",
        errorClass: "provider_unavailable",
        message: "The provider did not respond before the timeout.",
        retryable: true,
    },
};
//# sourceMappingURL=examples.js.map